import { useCallback, useContext } from 'react';
import type { ConfirmationDialogContextProps } from './ConfirmationDialogProvider.tsx';
import { ConfirmationDialogContext } from './ConfirmationDialogProvider.tsx';
import type { UseConfirmationDialogParams } from './types.ts';

export type UseConfirmationDialogInitialParams = Partial<UseConfirmationDialogParams>;

export function useConfirmationDialog(
  initialParams?: UseConfirmationDialogInitialParams
): ConfirmationDialogContextProps {
  const { open: contextOpen, ...restContextProps } = useContext(ConfirmationDialogContext);

  const open = useCallback(
    (openParams?: UseConfirmationDialogInitialParams) =>
      contextOpen({
        ...initialParams,
        ...openParams,
      }),
    [initialParams, contextOpen]
  );

  return {
    open,
    ...restContextProps,
  };
}
